var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 25C0 11.1929 11.1929 0 25 0C38.8071 0 50 11.1929 50 25C50 38.8071 38.8071 50 25 50C11.1929 50 0 38.8071 0 25Z",
    fill: "#BDBEC3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_152_532125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4004 19.2031H17.4535H33.8786",
    stroke: "#F3F3F3",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5328 19.2039V17.1508C20.5328 16.6063 20.7491 16.084 21.1342 15.699C21.5192 15.314 22.0414 15.0977 22.586 15.0977H26.6923C27.2368 15.0977 27.759 15.314 28.144 15.699C28.5291 16.084 28.7454 16.6063 28.7454 17.1508V19.2039M31.8251 19.2039V33.5759C31.8251 34.1204 31.6088 34.6427 31.2238 35.0277C30.8387 35.4127 30.3165 35.6291 29.772 35.6291H19.5063C18.9617 35.6291 18.4395 35.4127 18.0545 35.0277C17.6694 34.6427 17.4531 34.1204 17.4531 33.5759V19.2039H31.8251Z",
    stroke: "#F3F3F3",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5859 24.3359V30.4954",
    stroke: "#F3F3F3",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6914 24.3359V30.4954",
    stroke: "#F3F3F3",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_152_532125"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.6377,
    height: 24.6377,
    fill: "white",
    transform: "translate(12.3203 13.043)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete2);
export default __webpack_public_path__ + "static/media/delete_2.569e6287d39f81f4c71a1bd80e61ae6b.svg";
export { ForwardRef as ReactComponent };